module.exports = __webpack_public_path__ + "img/home--light.27714cca.svg";